import React from 'react'
import ReactDOM from 'react-dom'

require('../css/upcoming-broadcasts.css')

var Broadcast = React.createClass({
  propTypes: {
    broadcast: React.PropTypes.object.isRequired
  },
  handleClick: function() {
    this.props.clickAction(this.props.broadcast)
  },
  render: function() {
    if(this.props.broadcast.title){
      return (<button type="button" className="list-group-item" onClick={this.handleClick}>{this.props.broadcast.title} - {this.props.broadcast.startTime}</button>)
    }else{
      return(<button type="button" className="list-group-item" onClick={this.handleClick}>{this.props.broadcast.startTime}</button>)
    }
  }
})


var SingleBroadcast = React.createClass({
  propTypes: {
    broadcast: React.PropTypes.object.isRequired
  },
  handleClick: function(){
    this.props.onClose()
  },
  render: function() {
    var googleCalenderLink = window.Player.util.generateGoogleCalLink(this.props.broadcast, window.Player.broadcaster)
    if (this.props.broadcast.title) {
      return (
        <div className="broadcast-overlay-segment">
          <h2 className="header broadcast-title">{this.props.broadcast.title}</h2>
          <p className="header">{this.props.broadcast.startTime}</p>
          <a className="btn btn-streamspot broadcast-button btn-lg" target="_blank" href={googleCalenderLink}>
            <i className="fa fa-calendar"></i> Add a Reminder to Google Calendar</a>
          <p>
            <button className="btn btn-streamspot" style={{'marginTop': '5px'}} onClick={this.handleClick}><i className='fa fa-close'></i> Close</button>
          </p>
        </div>
      )
    } else {
      return (
        <div className="broadcast-overlay-segment">
          <h2 className="header broadcast-title">{this.props.broadcast.startTime}</h2>
          <a className="btn btn-streamspot broadcast-button btn-lg" target="_blank" href={googleCalenderLink}>
            <i className="fa fa-calendar"></i> Add a Reminder to Google Calendar</a>
          <p>
            <button className="btn btn-streamspot" style={{'marginTop': '5px'}} onClick={this.handleClick}><i className='fa fa-close'></i> Close</button>
          </p>
        </div>
      )
    }
  }
})

var UpcomingBroadcasts = React.createClass({
  propTypes: {
    broadcasts: React.PropTypes.array.isRequired
  },
  getInitialState: function() {
    return {view: 'list', broadcast: null}
  },
  switchToList(){
    this.setState({view: 'list', broadcast: null})
  },
  viewBroadcast(broadcast){
    this.setState({view: 'single',  broadcast: broadcast})
  },
  render: function() {
    switch (this.state.view) {
    case 'list':
      var broadcasts
      if (_.isEmpty(this.props.broadcasts)) {
        broadcasts = <button type="button" className="list-group-item">None Scheduled</button>
      } else {
        var broadcastList = _.filter(this.props.broadcasts, function(b) {
          return b.private === '0' || b.private === 0
        })
        var count = getQueryVariable('broadcastCount')
        if(!count){
          broadcastList = broadcastList.slice(0, 4)
        } else {
          broadcastList = broadcastList.slice(0, count)
        }

        broadcasts = broadcastList.map(function(broadcast, index) {
          return (
            <Broadcast clickAction={this.viewBroadcast} key={index} broadcast={broadcastList[index]}></Broadcast>
          )
        }.bind(this))
      }
      return (
        <section className="upcoming-broadcasts-section" style={{
          display: 'block'
        }}>
          <h2 className="header">
            Upcoming Broadcasts
          </h2>
          <ul className="list-group">
            {broadcasts}
          </ul>
        </section>
      )
    case 'single':
      return (<SingleBroadcast onClose={this.switchToList} broadcast={this.state.broadcast}/>)
    }
  }
})

function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return (false)
}

module.exports = UpcomingBroadcasts

window.UpcomingBroadcasts = {
  el: null,
  options: {},
  render: function(el, options){
    _.extend(this.options, options)
    this.el = el
    ReactDOM.render(React.createElement(UpcomingBroadcasts, options), document.getElementById(this.el))
  },
  unmount: function(){
    if(this.el) ReactDOM.unmountComponentAtNode(document.getElementById(this.el))
    this.el = null
  }
}



// WEBPACK FOOTER //
// ./src/components/UpcomingBroadcasts.jsx